import { ElementType, IElement } from "../../../models/Element";
import { ElementHeaderType } from "../../utils";

export type InfoBlockExpand = IElement & {
  title: string;
  heading: string;
  heading_type: ElementHeaderType;
  description: string;
  content: string;
};

export const defaultInfoBlockExpand: InfoBlockExpand = {
  id: 0,
  name: ElementType.INFO_BLOCK_EXPAND,
  title: "Hier vertellen wij over",
  heading: "De mogelijkheden van vast op mobiel",
  heading_type: ElementHeaderType.H1,
  description: `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>`,
  content: `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</p>`,
};
